import axios from "axios";

export async function getFromNetwork(url: string, params?: Record<string, string>): Promise<any> {
    const response = await axios.get(url, { params: params || {} });
    return response.data;
}